/* eslint-disable */

export const restrictions: Record<string, string[]> = {
    "bulleted-list": [
        "citation", "code", "heading-one", "heading-two", "heading-three", "image"
    ],
    "citation": [
        "bulleted-list", "code", "heading-one", "heading-two", "heading-three", "image", "italic", "numbered-list"
    ],
    "code": [
        "bold", "heading-one", "heading-two", "heading-three", "image", "italic", "link", "strike-through", "underline"
    ],
    "heading-one": [
        "bold", "bulleted-list", "citation", "code", "image", "italic", "link", "numbered-list", "strike-through", "underline"
    ],
    "heading-two": [
        "bold", "bulleted-list", "citation", "code", "image", "italic", "link", "numbered-list", "strike-through", "underline"
    ],
    "heading-three": [
        "bold", "bulleted-list", "citation", "code", "image", "italic", "link", "numbered-list", "strike-through", "underline"
    ],
    "list-item": [
        "citation", "code", "heading-one", "heading-two", "heading-three", "image"
    ],
    "numbered-list": [
        "citation", "code", "heading-one", "heading-two", "heading-three", "image"
    ],
};


/* eslint-enable */
